<template>
    <drop-down ref="dropDown" :label="label" inner_cls="snap_drop_nav">
        <li
            v-for="nav in navList"
            :key="nav.id"
            class="item"
            @click="handleClick(nav)"
        >
            {{ nav.name }}
        </li>
    </drop-down>
</template>

<script>
import { mapState } from '@/store/helpers';

import navCommon from '../../../_mixins/nav/common';
import DropDown from '../../../../../components/dropdown-slot';

export default {
    name: 'drop-down-nav',
    mixins: [navCommon],
    components: { 'drop-down': DropDown },
    props: {
        navList: {
            type: Array,
            required: true
        },
        // pc end use ， pass more
        customLabel: {
            type: String,
            default: ''
        }
    },
    computed: {

        ...mapState({
            "currentListingStatusName": "currentListingStatusName"
        }),
        
        label() {
            return this.customLabel || this.currentListingStatusName;
        }
    },
    methods: {
        //  Handle the click event
        handleClick(listing) {
            this.$refs['dropDown'].close();
            this.switchNav(listing);
        }
    }
};
</script>

<style lang="scss">
.snap_drop_nav {
    background: #fff;
    left: auto !important;
    right: 5px;
    overflow: auto;
    box-shadow: 0 2px 5px 0px #000a1e;
    max-height: 216px !important;
    .item {
        border-bottom: 1px solid var(--color-border);
        line-height: 35px;
        cursor: pointer;
        padding: 0 20px;
        white-space: nowrap;
        &:hover {
            color: var(--color-hover);
        }
    }
}
</style>
